export default __webpack_public_path__ + "static/media/RCSP_GOLD.3869cc4a.jpg";